import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { useLibraryVM } from '../view-models/library.viewModel';
import { LibraryView } from './library.view';
import { PageWrapper } from '../components/PageWrapper';

export const LibraryPage = (p: { params: { influencerId: string } }) => {
  const influencerId = parseInt(p.params.influencerId) || 0;
  const vm = useLibraryVM({ influencerId });
  return (
    <PageWrapper {...vm}>
      <AsyncRenderer data={vm} renderer={LibraryView} loadRender={<Loader />} />
    </PageWrapper>
  );
};

const Loader = () => (
  <div className="mt-[90px]">
    <TableLoader rows={5} height={130} />
  </div>
);
